import React, { useEffect, useState } from 'react';
import { toastr } from 'react-redux-toastr';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useLocation, useHistory } from 'react-router-dom';
import { IconButton, Icon, Grid, Button, Tooltip, Alert, Box, CircularProgress } from '@material-ui/core';
import { green, red } from '@material-ui/core/colors';
import TheatersIcon from '@material-ui/icons/Theaters';
import PhotoIcon from '@material-ui/icons/Photo';
import EditIcon from '@material-ui/icons/Edit';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import DeleteIcon from '@material-ui/icons/Delete';
import VisibilityIcon from '@material-ui/icons/Visibility';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';

import { toggleShowDialog } from '../../store/actions/dialog';
import { deletarProduto, getProdutos } from '../../store/actions/produto';
import TituloPagina from '../../components/layout/TituloPagina';
import moedaBr from '../../assets/js/moedaBr';
import DataTableComponent from '../../components/form/DataTableComponent';
import DialogAlert from '../../components/layout/DialogAlert';
import { getNegocio } from '../../store/actions/negocio';
import LoadingOverlay from '../../components/layout/LoadingOverlay';

const Produto = props => {
    const history = useHistory();
    const location = useLocation();
    const {
        produtos,
        toggleShowDialog,
        getProdutos,
        deletarProduto,
        negocioDoUsuario,
        negocio,
        getNegocio,
        loading
    } = props
    const [toggleDeleteDialog, setToggleDeleteDialog] = useState(false);

    useEffect(() => {
        getProdutos(negocioDoUsuario);
        getNegocio(negocioDoUsuario);
    }, [getProdutos, negocioDoUsuario]);

    const columns = [
        {
            name: 'ID',
            selector: (row) => row.id,
            width: '70px',
            sortable: true,
        },
        {
            name: 'Produto',
            selector: (row) => row.nome,
            sortable: true,
        },
        {
            name: <>Preço<br />Original</>,
            selector: (row) => moedaBr(row.preco),
            right: 'true',
            headerStyle: { whiteSpace: 'normal' },
            width: '115px'
        },
        {
            name: <>Preço<br />Promocional</>,
            selector: (row) => moedaBr(row.precoPromocional),
            right: 'true',
            headerStyle: { whiteSpace: 'normal' },
            width: '115px'
        },
        {
            name: <>Preço<br />Atacado</>,
            selector: (row) => moedaBr(row.precoAtacado),
            right: 'true',
            headerStyle: { whiteSpace: 'normal' },
            width: '115px'
        },
        {
            name: 'Estoque',
            selector: (row) => row.estoque,
            center: 'true',
            width: '105px',
            sortable: true,
        },
        {
            name: 'Ativo',
            center: 'true',
            selector: (row) => (
                row.ativo ? <CheckCircleIcon style={{ color: green[500] }} /> : <CancelIcon style={{ color: red[500] }} />
            ),
            width: '70px',
        },
        {
            name: <Tooltip title='Quantidade de visualizações' placement='right'><VisibilityIcon /></Tooltip>,
            selector: (row) => row.visualizacoes,
            center: 'true',
            width: '70px',
        },
        {
            name: <Tooltip title='Quantidade de vendas' placement='right'><MonetizationOnIcon /></Tooltip>,
            selector: (row) => row.vendas,
            center: 'true',
            width: '70px',
        },
        {
            name: 'Ações',
            center: 'true',
            cell: (row) => (
                <>
                    <Tooltip title='Editar Produto' placement='right'>
                        <IconButton style={{ padding: 1 }} aria-label="editar" size='small' color='secondary' onClick={() => handleEditarProduto(row.id)}><EditIcon /></IconButton>
                    </Tooltip>
                    <Tooltip title='Adicionar/Editar Imagens' placement='right'>
                        <IconButton style={{ padding: 1 }} aria-label="imagens" size='small' color='secondary' onClick={() => handleAddImagensDoProduto(row.id)}><PhotoIcon /></IconButton>
                    </Tooltip>
                    <Tooltip title='Adicionar/Editar Vídeo' placement='right'>
                        <IconButton style={{ padding: 1 }} aria-label="video" size='small' color='secondary' onClick={() => handleAddVideoDoProduto(row.id)}><TheatersIcon /></IconButton>
                    </Tooltip>
                    <Tooltip title='Desativar Produto' placement='right'>
                        <IconButton style={{ padding: 1 }} aria-label="excluir" size='small' color='secondary' onClick={() => handleDeletaProduto(row)}><DeleteIcon /></IconButton>
                    </Tooltip>
                </>
            ),
            width: '125px'
        }
    ];

    const handleEditarProduto = (id) => {
        history.push({
            pathname: '/produtos/editar-produto',
            state: {
                produtoId: id,
                from: window.location.pathname,
            },
        });
    }

    const handleAddImagensDoProduto = (id) => {
        history.push({
            pathname: '/produtos/imagens-do-produto',
            state: {
                produtoId: id,
                from: window.location.pathname,
            },
        });
    }

    const handleAddVideoDoProduto = (id) => {
        history.push({
            pathname: '/produtos/video-do-produto',
            state: {
                produtoId: id,
                from: window.location.pathname,
            },
        });
    }

    const handleDeletaProduto = (row) => {
        toggleShowDialog(row);
        setToggleDeleteDialog(true);
    }

    const handleCancelarDelete = () => {
        setToggleDeleteDialog(false);
    }

    const handleConfirmarDelete = (idDialogShow) => {
        deletarProduto(idDialogShow);
        setToggleDeleteDialog(false);
    }

    const handleClickAdicionar = () => {
        if (negocio.stripePayoutsEnabled) {
            history.push({
                pathname: "/produtos/cadastrar-produto",
                state: { from: location.pathname },
            });
        } else {
            toastr.warning('Atenção', 'A integração com a Stripe ainda não foi realizada. Verifique seu e-mail.');
        }
    };

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, height: '70vh' }}>
                <CircularProgress size={48} />
            </Box>
        );
    }

    return (
        <>
            <TituloPagina titulo='Produtos' subtitulo={new Date().toLocaleString('pt-BR')} />
            <Box sx={{ height: '70vh' }}>
                <DataTableComponent
                    columns={columns}
                    data={produtos}
                    visibleSearch={produtos && produtos.length > 0}
                    camposParaBusca={['nome']}
                />
                <Grid container >
                    <Button variant='contained' color='secondary' onClick={handleClickAdicionar}>Adicionar Produto</Button>
                </Grid>
            </Box>
            <DialogAlert
                title='Excluir Produto'
                okButton={true}
                labelOkButton='Confirmar'
                okButtonClick={handleConfirmarDelete}
                cancelButton={true}
                labelCancelButton='Cancelar'
                cancelButtonClick={handleCancelarDelete}
                openDialog={toggleDeleteDialog}>
                Tem certeza que deseja excluir o produto?
            </DialogAlert>
        </>
    )
}

const mapStateToProps = state => ({
    produtos: state.produto.produtos,
    idDialogShow: state.dialog.idDialogShow,
    negocioDoUsuario: state.negocio.negocioDoUsuario,
    negocio: state.negocio.negocio,
    loading: state.produto.loading
})
const mapDispatchToProps = dispatch => bindActionCreators({
    toggleShowDialog,
    getProdutos,
    deletarProduto,
    getNegocio
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Produto)